var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 805,
    height: 805,
    viewBox: "0 0 805 805",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2364_33755)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2364_33755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M712.31 373.575C712.31 487.039 577.355 533.147 409.791 533.147C242.226 533.147 105.307 487.039 105.307 373.575C105.307 260.111 241.244 168.297 408.808 168.297C576.373 168.297 712.31 260.311 712.31 373.575Z",
    fill: "#4BAF74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.513 126.544C681.513 66.8049 633.975 18.2919 575.435 18.2919C542.433 18.2919 512.967 33.7279 493.519 57.7839C467 51.7699 438.712 48.3619 409.442 48.3619C380.173 48.3619 351.885 51.5694 325.365 57.7839C305.721 33.7279 276.255 18.2919 243.449 18.2919C184.91 18.2919 137.371 66.8049 137.371 126.544C137.371 146.19 142.479 164.432 151.318 180.269C142.871 198.712 138.353 218.358 138.353 238.805C138.353 344.051 259.754 429.249 409.442 429.249C559.131 429.249 680.531 344.051 680.531 238.805C680.531 218.358 676.013 198.712 667.566 180.269C676.406 164.432 681.513 146.19 681.513 126.544Z",
    fill: "#32DA6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.9 186.766C270.702 186.766 299.725 157.148 299.725 120.612C299.725 84.0763 270.702 54.4581 234.9 54.4581C199.098 54.4581 170.074 84.0763 170.074 120.612C170.074 157.148 199.098 186.766 234.9 186.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.798 186.766C616.6 186.766 645.624 157.148 645.624 120.612C645.624 84.0763 616.6 54.4581 580.798 54.4581C544.996 54.4581 515.973 84.0763 515.973 120.612C515.973 157.148 544.996 186.766 580.798 186.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.288 525.351C214.235 525.351 225.236 512.922 223.664 498.89C217.967 449.174 193.805 341.523 87.5303 276.772C-53.9074 190.571 58.0641 487.262 58.0641 487.262L28.7943 504.503C18.9723 510.316 23.0975 525.351 34.2947 525.351H200.288Z",
    fill: "#32DA6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.343 525.351C609.771 525.351 599.949 512.922 601.324 498.89C606.235 449.374 628.236 341.523 724.1 276.772C851.983 190.571 750.816 487.262 750.816 487.262L777.335 504.503C786.175 510.316 782.443 525.351 772.424 525.351H622.343Z",
    fill: "#32DA6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.017 132.288C241.526 132.288 246.803 126.903 246.803 120.26C246.803 113.617 241.526 108.232 235.017 108.232C228.507 108.232 223.23 113.617 223.23 120.26C223.23 126.903 228.507 132.288 235.017 132.288Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.589 132.288C587.099 132.288 592.376 126.903 592.376 120.26C592.376 113.617 587.099 108.232 580.589 108.232C574.08 108.232 568.803 113.617 568.803 120.26C568.803 126.903 574.08 132.288 580.589 132.288Z",
    fill: "#0D0D0D"
  })), /*#__PURE__*/React.createElement("rect", {
    y: 586,
    width: 805,
    height: 310,
    fill: "#AC4BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2364_33755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 805,
    height: 805,
    rx: 144.9,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2364_33755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 772.8,
    height: 515.2,
    fill: "white",
    transform: "translate(16 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeap);
export default __webpack_public_path__ + "static/media/leap.dc09b21617808fc0be12c0c66be12785.svg";
export { ForwardRef as ReactComponent };